import { parseStructuredArtifact, type StructuredAssistantArtifact } from './structured';
import { parseScheduleArtifact, type ScheduleArtifact } from '@/app/ai-assistant/workspace/scheduleArtifact';

export type AssistantArtifact = ScheduleArtifact | StructuredAssistantArtifact;

export type AssistantArtifactLibraryItem = {
  id: string;
  conversationId?: string;
  createdAt: string;
  artifact: AssistantArtifact;
};

type StoredArtifactRow = {
  id?: unknown;
  conversation_id?: unknown;
  artifact_type?: unknown;
  data?: unknown;
  created_at?: unknown;
};

function record(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;
}

export function parseStoredAssistantArtifact(value: unknown): AssistantArtifactLibraryItem | null {
  const row = record(value) as StoredArtifactRow | null;
  if (!row || typeof row.id !== 'string' || typeof row.artifact_type !== 'string' || typeof row.created_at !== 'string') return null;
  const storedData = record(row.data);
  if (!storedData) return null;
  const { runId: _runId, ...artifactData } = storedData;
  const result = {
    data: {
      artifactId: row.id,
      artifactType: row.artifact_type,
      ...artifactData,
    },
  };
  const artifact = parseScheduleArtifact(result) ?? parseStructuredArtifact(result);
  if (!artifact) return null;
  return {
    id: row.id,
    conversationId: typeof row.conversation_id === 'string' ? row.conversation_id : undefined,
    createdAt: row.created_at,
    artifact,
  };
}

export function artifactKindLabel(artifact: AssistantArtifact): string {
  if (artifact.artifactType === 'scarlet.schedule-options.v1') return 'Schedule options';
  if (artifact.artifactType === 'scarlet.document.v1') return 'Document';
  return 'Spreadsheet';
}
